<template>
  <div class="modal_compare_configs">
    <div class="header">
      <h4 class="title">
        {{ translate('config.compare_configs') }}
      </h4>
    </div>

    <div class="content">
      <div class="left">
        <span style="display: flex; justify-content: center">
          {{ translate('config.current_config') }}
        </span>
        <input
            type="text"
            class="form-control"
            v-model="current_ver"
            :disabled="true"
            :placeholder="translate('support.search')"
          >
      </div>

      <div class="right">
        <span style="display: flex; justify-content: center">
          {{ translate('config.new_config') }}
        </span>
        <input
            type="text"
            class="form-control"
            v-model="last_ver"
            :disabled="true"
            :placeholder="translate('support.search')"
          >
      </div>
    </div>

    <div class="result_wrap">

      <div class="legend">
        <span class="add">
          {{ translate('config.legend.add') }}
        </span>
        <span class="del">
          {{ translate('config.legend.del') }}
        </span>
        <span class="mod">
          {{ translate('config.legend.mod') }}
        </span>
      </div>

      <div class="result">
        <CodeDiff
            :old-string="old_config.config"
            :new-string="new_config.config"
        />
      </div>

    </div>

    <div class="text-center">
      <span
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="save"
      >
        {{ translate('btn.apply') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

import CodeDiff from "vue-code-diff";

export default {
  name: "CompareConfigs",
  props: ["dev_id", "current_ver", "last_ver"],
  components: {
    CodeDiff
  },
  data () {
    return {
      old_config: {
        config: ""
      },
      new_config: {
        config: ""
      },
    }
  },

  created() {
    this.compare()
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    selected_block(block){
      this.block = block
    },
    compare(){
      let params = {
        config_old_version: this.current_ver,
        config_new_version: this.last_ver
      }
      this.$http.v1.compareConfigs(this.dev_id, params, (response) => {
        this.old_config.config = response.data.old_version?.main
        this.new_config.config = response.data.new_version?.main
      })
    },
    save(){
      this.$emit("save")
    }
  }
}

</script>

<style lang='scss'>
  .modal_compare_configs{
    padding: 10px;
    .header{
      text-align: center;
      .title{
        margin: 0 0 10px 0;
      }
    }
    .content{
      display: flex;
      .left, .right{
        width: 50%;
        .select_version{

        }
        .configuration{
          height: 200px;
          width: 100%;
          outline: none;
          resize: none;
          &::-webkit-scrollbar{
            width: 10px;
            cursor: pointer;
          }
        }
      }
      .left{
        padding: 0 5px 5px 0;
      }
      .right{
        padding: 0 0 5px 5px;
      }
    }
    .result{
      height: 400px;
      overflow: auto;
      &::-webkit-scrollbar{
        width: 10px;
      }
      &_wrap{
        .legend{
          display: flex;
          justify-content: space-around;
          margin-bottom: 10px;
          .add, .del, .mod{
            position: relative;
            font-size: 13px;
            line-height: 100%;
            &:before{
              position: absolute;
              left: -15px;
              width: 13px;
              height: 13px;
              content: "";
            }
          }
          .add {
            &:before{
              background-color: #dfd;
            }
          }
          .del{
            &:before{
              background-color: #ffb6ba;
            }
          }
          .mod{
            &:before{
              background-color: #fdf2d0;
            }
          }
        }
      }
    }
  }
</style>
